import React, { Component } from 'react';
import { Switch, Route } from 'react-router-dom';
import { Route as RouteType } from '../Types/Route';
import PrivateRoute from './PrivateRoute';

type Props = {
	routes: RouteType[],
}

class App extends Component<Props> {
	render(): React.ReactElement {
		const { routes } = this.props;
		return (
			<Switch>
				{routes.map(({ component, ...r }: RouteType) => {
					if (r.private === true) {
						return (<PrivateRoute key={r.name} component={component} {...r} />);
					}
					return (<Route key={r.name} component={component} {...r} />);
				})}
			</Switch>
		);
	}
}

export default App;
